import React from 'react';

import styles from './styles';

const {
    OutlinedButton,
} = styles;

const ButtonOutlined = ({
    onClick, href, title, status,
}) => (
    <OutlinedButton
        status={status}
        href={href}
        onClick={event => {
            if (onClick) {
                event.preventDefault();
                onClick().then(() => {
                    window.location.href = href;
                });
            } else {
                window.location.href = href;
            }
        }}
    >
        {
            title
        }
    </OutlinedButton>
);

export default ButtonOutlined;
